import { useQuery } from "@tanstack/react-query"
import { messengerIntegrationsQuery } from "modules/settings/lib/messenger/messengerIntegrationsQuery"

export function useMessengerIntegrationsQuery(
  ...args: Parameters<typeof messengerIntegrationsQuery>
) {
  return useQuery(messengerIntegrationsQuery(...args))
}
